export * from "./VoiceConfigurationDTO";
